import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import './SettingsHub.css';

/**
 * Manager settings hub at /manager. Visible to manager, exec-manager,
 * administrator, and super-admin roles.
 *
 * Phase 1 placeholder — surfaces the planned manager-facing tools as
 * cards with status badges. The functional implementations (caseload
 * reassignment, staff-view configuration) land in Phase 2/3 of the
 * project plan.
 */
export function ManagerSettings() {
  const { t } = useTranslation();
  return (
    <div className="settings-hub">
      <h1 className="settings-hub__title">{t('managerHub.title')}</h1>
      <p className="settings-hub__subtitle">{t('managerHub.subtitle')}</p>
      <div className="settings-hub__grid">
        <Link to="/manager/caseload" className="settings-hub__card">
          <h2>{t('managerHub.cards.caseload.title')}</h2>
          <p>{t('managerHub.cards.caseload.desc')}</p>
        </Link>
        <Link to="/manager/views" className="settings-hub__card">
          <h2>{t('managerHub.cards.views.title')}</h2>
          <p>{t('managerHub.cards.views.desc')}</p>
        </Link>
        <Link to="/manager/signoffs" className="settings-hub__card">
          <h2>{t('managerHub.cards.signoff.title')}</h2>
          <p>{t('managerHub.cards.signoff.desc')}</p>
        </Link>
      </div>
    </div>
  );
}

export default ManagerSettings;
